/*
 * @Author: qianyl
 * @Descripttion: 
 * @Date: 2024-11-15 15:06:58
 * @LastEditors: qianyl
 * @LastEditTime: 2024-12-12 10:46:12
 * @FilePath: \lesson-web-cms\src\api\selectUsr.ts
 */
import axios from '@/axios/index'
const baseUrl = "/page/login";

const URLS = {
  usrInfo: baseUrl + '/api/dx/oauth2/moreUser.do',
  loginSelf: baseUrl + '/api/dx/oauth2/loginSelf.do',
  moreUserLogin: baseUrl + "/api/dx/oauth2/moreUserLogin.do"
}

export const getMoreUserInfo = (token: string) => {
  return axios.get(URLS.usrInfo + '?accessToken=' + token)
}

export const getLoginSelf = (params: {userId: string, orgType: string}) => {
  return axios.get(URLS.loginSelf + `?userId=${params?.userId}&orgType=${params?.orgType}`)
}

export const getMoreUserLogin = () => {
  return axios.get(URLS.moreUserLogin)
}